import React from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import styled from "styled-components";
import * as authActions from "../../../auth/auth.actions";
import { getCurrentUser } from "../../../user/user.selectors";
import { getCurrentCampaign } from "../../../campaign/campaign.selectors";
import { DesktopMainNavigation, MobileHamburgerNavigation } from "./MainNavigation";
import MediaQuery, { useMediaQuery } from 'react-responsive';
import { sizes } from '../../../../utils/uiSizes';
import SecondaryNavigation from "./SecondaryNavigation";
import colors from "../../../../utils/colors";
import { rem } from "polished";
import ScoreAndTime from "./ScoreAndTime";
import BaseContainer from "../../../../ui/BaseContainer";
import LogoMtv from "../../../../ui/LogoMtv";
import { media, mediaMax } from "../../../../utils/uiSizes";

const Header = styled.header`
display: flex;
gap:3.5rem;
margin-left:auto;
margin-right:auto;
width: fit-content;
height:46px;
align-items: center;
min-width: 320px;
${mediaMax.desktop`
gap:0.5rem;
width:95vw;

`}
${mediaMax.phone`
width:unset;
gap:0.25rem;
flex-direction: row;

margin-left:0rem;
`}

 ${media.tablet`
padding: 0 0 ${rem("25px")} 0;

`} ${media.desktop`
position: relative;
max-width: 1066px;
z-index: 100;
`}
`;

const StyledNaviWrapper = BaseContainer.extend`
  flex-shrink: 1;
  margin: auto auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const StyledSecondaryNaviWrapper = styled.div`
  display: none;
  flex: 1;
  flex-basis: 210px;
  ${media.desktop`
    margin-top:1rem;
    display: flex;
    width:140px;
  `};
`;
const First = styled.div`
${media.desktop`

`}
`;
const Third = styled.div`

`;

const Second = styled.div`
margin-left: auto;
margin-right: auto;
max-width: 627px;
display:block;
@media (max-width:321px) {
  display:none;
}
`;

const AppHeader = props => {
  const { currentUser, currentCampaign, logoutUser } = props;

  return (
    <Header>
      <First>
        <NavLink to="/">
          <LogoMtv />
        </NavLink>
      </First>
      <MediaQuery minWidth={sizes.desktop}>
        {(matches) =>
          matches ? <StyledNaviWrapper>
            <DesktopMainNavigation currentUser={currentUser} />
          </StyledNaviWrapper>
            : <Second /> }
      </MediaQuery>
      <Third>
        {currentCampaign &&
          currentUser.hasAccessToPrizeProgram && (
            <ScoreAndTime score={currentUser.score} campaign={currentCampaign} />
          )}
      </Third>
      <StyledSecondaryNaviWrapper>
        <SecondaryNavigation currentUser={currentUser} onLogoutClick={logoutUser} />
      </StyledSecondaryNaviWrapper>
      <MobileHamburgerNavigation currentUser={currentUser} onLogoutClick={logoutUser} />
    </Header>

  );
};

const mapStateToProps = state => {
  const currentUser = getCurrentUser(state);
  const currentCampaign = getCurrentCampaign(state);
  return {
    currentUser,
    currentCampaign
  };
};

const ConnectedAppHeader = connect(mapStateToProps, Object.assign({}, authActions))(AppHeader);

export default ConnectedAppHeader;



// WEBPACK FOOTER //
// ./src/modules/common/components/app/AppHeader.js